import { render, staticRenderFns } from "./CreateUpdateTree.vue?vue&type=template&id=28d52ecf"
import script from "./CreateUpdateTree.vue?vue&type=script&lang=js"
export * from "./CreateUpdateTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports